import * as React from 'react'
import Element, { elementSubtotal } from './element'
import { OrderElement } from '../order_types'

type ElementListProps = {
  elements: OrderElement[]
  editElement: (element: OrderElement) => void
  removeElement: (key: string, id: number) => void
  inputAttributeName: (name: string, row: string) => string
}

export default function ElementList(props: ElementListProps) {
  const { elements, editElement, removeElement, inputAttributeName } = props
  return (
    <>
      {Object.values(elements || {}).map((element, index) => {
        const id = element.id === undefined ? element.key : element.id
        return (
          <Element
            key={id}
            element={element}
            row={index.toString()}
            inputAttributeName={inputAttributeName}
            subtotal={elementSubtotal(element)}
            editElement={editElement}
            removeElement={removeElement}
          />
        )
      })}
    </>
  )
}
